import { magnoliaServiceAPI } from '@/store/api-instance'

const categoriesApi = '/becameupcoming/GetBecameMoreSustainable'
const contentApi = '/becameupcoming/GetBecameMoreSustainableSubcontent'

export const becomeSustainableApi = {
  async getBecomeSustainable () {
    return (await this._getAndReturnResults(categoriesApi))
  },

  async getBecomeSustainableContent () {
    return (await this._getAndReturnResults(contentApi))
  },

  async _getAndReturnResults (url: string) {
    const response = await magnoliaServiceAPI.get(url)
    return response.data.results || []
  }
}
